<template>
  <el-menu ref="slideoutMenu"
          style="padding-bottom: 120px"
          mode="vertical"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
          @select="handleMenuSelect">
    <template v-for="(menu, menuIndex) in menuHeader">
      <d2-layout-header-aside-menu-item v-if="menu.children === undefined" :menu="menu" :isMobileLayer="true" :key="menuIndex"/>
      <d2-layout-header-aside-menu-sub v-else :menu="menu" :isMobileLayer="true" :key="menuIndex"/>
    </template>
  </el-menu>
</template>

<script>
import { mapState } from 'vuex'
import menuMixin from '../mixin/menu'
import d2LayoutMainMenuItem from '../components/menu-item/index.vue'
import d2LayoutMainMenuSub from '../components/menu-sub/index.vue'
export default {
  name: 'd2-layout-header-aside-menu-header',
  mixins: [
    menuMixin
  ],
  mounted() {
    this.$children[0].$parent = this.$parent
  },
  methods: {
      //覆盖选中事件，增加关闭侧边栏事件
      handleMenuSelect (index, indexPath) {
          //this.$emit('closeSlideout')
          if (/^d2-menu-empty-\d+$/.test(index)) {
              this.$message.warning('临时菜单')
          } else {
              this.$router.push({
                  path: index
              },() => {this.$emit('closeSlideout')})
          }
      }
  },
  components: {
    'd2-layout-header-aside-menu-item': d2LayoutMainMenuItem,
    'd2-layout-header-aside-menu-sub': d2LayoutMainMenuSub
  },
  computed: {
    ...mapState({
      menuHeader: state => state.d2admin.menuHeader
    })
  },
  watch: {
      '$route': {
          handler (val) {
              this.active = val.fullPath
              if(this.active.endsWith('/')){
                  this.active = this.active.substr(0,this.active.length-1)
              }
              this.$nextTick(() => {
                  if (this.menuHeader.length > 0) {
                      this.$refs.slideoutMenu.activeIndex = this.active
                  }
              })
          },
          immediate: true
      }
  }
}
</script>
